import { CONTROL } from '../../components';
var SpecificationItem = {
  Velocity: 'velocity',
  Traffic: 'traffic'
};
var specificationItems = [{
  value: SpecificationItem.Velocity,
  label: 'Пропускная способность'
}, {
  value: SpecificationItem.Traffic,
  label: 'Количество трафика'
}];
export function getEip(_ref) {
  var _ref$switchKey = _ref.switchKey,
    switchKey = _ref$switchKey === void 0 ? 'eipIsNeeded' : _ref$switchKey,
    _ref$velocityKey = _ref.velocityKey,
    velocityKey = _ref$velocityKey === void 0 ? 'eip.velocity' : _ref$velocityKey,
    _ref$trafficKey = _ref.trafficKey,
    trafficKey = _ref$trafficKey === void 0 ? 'eip.trafficKey' : _ref$trafficKey,
    _ref$specificationKey = _ref.specificationKey,
    specificationKey = _ref$specificationKey === void 0 ? 'eip.specification' : _ref$specificationKey;
  return {
    type: CONTROL.ToggleObject,
    switchKey: switchKey,
    decoratorProps: {
      label: 'Доступ в интернет'
    },
    control: {
      type: CONTROL.Object,
      ui: [['specification', 'velocity', 'traffic']],
      controls: {
        velocity: {
          type: CONTROL.Stepper,
          accessorKey: velocityKey,
          defaultValue: 100,
          decoratorProps: {
            label: 'Скорость',
            labelTooltip: 'Пропускная способность выделенной сети'
          },
          uiProps: {
            min: 1,
            max: 2000,
            step: 1,
            postfix: 'Mбит/сек'
          },
          watchedControls: {
            specification: specificationKey
          },
          relateFn: function relateFn(_ref2) {
            var specification = _ref2.specification;
            if (specification === SpecificationItem.Traffic) {
              return {
                uiProps: {
                  visible: false
                }
              };
            }
          }
        },
        traffic: {
          type: CONTROL.Stepper,
          accessorKey: trafficKey,
          defaultValue: 1,
          decoratorProps: {
            label: 'Количество трафика'
          },
          uiProps: {
            min: 1,
            max: 9999999999,
            showHint: false,
            postfix: 'ГБ',
            step: 1
          },
          watchedControls: {
            specification: specificationKey
          },
          relateFn: function relateFn(_ref3) {
            var specification = _ref3.specification;
            if (specification === SpecificationItem.Velocity) {
              return {
                uiProps: {
                  visible: false
                }
              };
            }
          }
        },
        specification: {
          type: CONTROL.SelectSingle,
          accessorKey: specificationKey,
          defaultValue: SpecificationItem.Velocity,
          items: specificationItems,
          decoratorProps: {
            label: 'Способ тарификации доступа в интернет'
          }
        }
      }
    }
  };
}